import React, {useState} from 'react';
import styles from './Info.module.scss';
import {Link, useParams} from "react-router-dom";
import {InfoSchema} from "./Info.schema";
import {GeneralMethods} from "@/views/Admin/Events/Event/General/General.methods";
import {InfoPropsInterface} from "@/views/Admin/Events/Event/General/Info/Info.props.interface";

import {Button, Input, Preloader, Switcher, Toggletip, useToast} from "uikit";

import ImportIcon from '@/assets/images/icons/12/import.svg';
import CalendarIcon from '@/assets/images/icons/12/calendar.svg';
import PointIcon from '@/assets/images/icons/12/point.svg'
import TicketIcon from '@/assets/images/icons/16/ticket.svg';
import LockIcon from '@/assets/images/icons/16/lock.svg';
import UserIcon from '@/assets/images/icons/16/user.svg';
import ArrowDownIcon from '@/assets/images/icons/12/arrow-down.svg';
import ToggletipIcon from '@/assets/images/icons/16/toggletip-icon.svg';

import imageCompression from 'browser-image-compression';
import {putFile} from "@/utils/sendData";
import {useTranslation} from "react-i18next";
import {deserializedData} from "@/utils/deserializedData";
import LandingInfo from "@/views/Admin/Events/Event/General/Info/Section/LandingInfo/LandingInfo";
import StatusInfo from "@/views/Admin/Events/Event/General/Info/Section/StatusInfo/StatusInfo";

const options = {
    maxSizeMB: 3,
    maxWidthOrHeight: 1280,
    useWebWorker: true,
}

const Info = ({data, onChange, onUpdate}: InfoPropsInterface) => {
    const [content, setContent] = useState({...InfoSchema, ...data});
    const params: { id: any } = useParams();
    const {t} = useTranslation('common');
    const addToast = useToast();

    const {
        patchEventParams,
        getUploadImageUrl,
        reportUploadImg,
        getEventAfisha,
    } = GeneralMethods;

    const permissionsType = content.eventType === 'courses' ? content?.permissions?.courses : content?.permissions?.events;

    const handleChange = async (field, value) => {
        let response, data = {};
        try {
            data[field] = value;
            response = await patchEventParams(content.eventType, params.id, data);
            if ([200, 201].includes(response.status)) {
                setContent((prev) => (
                    {...prev,
                        fields: {...prev.fields,
                            [field]: {...prev.fields[field], value: value}}})
                )

                return await deserializedData(response.data)
            }
        } catch (err) {
            console.log(err)
            // @ts-ignore
            addToast({
                message: 'Произошла ошибка',
                type: 'danger',
                duration: 3000,
            });
        }
    }

    const handleEditTitle = () => {
        setContent(prev => ({...prev, isTitleEdit: true, newEventTitle: String(content.fields.title.value)}))
    }

    const handleChangeTitle = (e) => {
        const {value} = e.target;
        setContent(prev => ({...prev, newEventTitle: value}));
    }

    const handleAcceptEdit = () => {
        handleChange('title', content.newEventTitle);
        setContent(prev => ({...prev, isTitleEdit: false}));
    }

    const handleCancelEdit = () => {
        setContent(prev => ({...prev, isTitleEdit: false}));
    }

    const handleShowMoreInfo = () => {
        setContent(prev => ({...prev, isShowMore: !content.isShowMore}));
    }

    const handleHidden = async () => {
        const res = await handleChange('isHidden', !content.fields.isHidden.value);
        setContent(prev => ({...prev, landingUrl: res.landing_url}));
    }

    const handleSwitchWidget = () => {
        handleChange('isWidget', !content.fields.isWidget.value);
    }

    const handleUploadImage = async (e) => {
        const file = await imageCompression(e.target.files[0], options);
        let data = {
            filename: file.name,
            mime: file.type,
            size: file.size
        };
        setContent(prev => ({...prev, fields: {...prev.fields, afishaImage: {...prev.fields.afishaImage, isLoading: true}}}));
        try {
            let response = await getUploadImageUrl(data, content.eventAfishaId);
            if ([200,201].includes(response.status)) {
                let presignedUrl = response.data.data.presigned_url;
                let fileId = response.data.data.file_id;

                await putFile(presignedUrl, file, null);
                let reportResponse = await reportUploadImg(fileId,  content.eventAfishaId)
                if (reportResponse.data.success) {
                    addToast({
                        message: 'Изображение успешно загружено',
                        type: 'success',
                        duration: 3000,
                    });
                    let updateImage = await getEventAfisha(content.eventType, params.id)
                    setContent(prev => ({...prev, fields: {...prev.fields, afishaImage: {...prev.fields.afishaImage, value: updateImage.image, isLoading: false}}}))
                }
            } else {
                addToast({
                    message: 'Произошла ошибка',
                    type: 'danger',
                    duration: 3000,
                });
            }
        } catch ({response}) {
            setContent(prev => ({...prev, fields: {...prev.fields, afishaImage: {...prev.fields.afishaImage, isLoading: false}}}))
            if (response.status === 422) {
                addToast({
                    message: `${response.data.message}`,
                    type: 'danger',
                    duration: 3000,
                });
            } else {
                addToast({
                    message: 'Произошла ошибка',
                    type: 'danger',
                    duration: 3000,
                });
            }
        }
    }

    return (
        <div className={styles.container}>
            <p className={styles.subtitle}>
                {content.fields.type.value}
            </p>
            <div className={styles.title}>
                {content.isTitleEdit ? <div className={styles.editInput}>
                    <Input
                        size={'small'}
                        value={content.newEventTitle}
                        onChange={(e) => handleChangeTitle(e)}
                    />
                    <Button
                        size={'small'}
                        theme={'outline'}
                        type={'secondary'}
                        onClick={handleAcceptEdit}
                        fill={true}
                    >
                        {t('save')}
                    </Button>
                    <Button
                        size={'small'}
                        theme={'default'}
                        type={'secondary'}
                        onClick={handleCancelEdit}
                        fill={true}
                    >
                            {t('cancel')}
                    </Button>
                </div> : null}
                {!content.isTitleEdit ? <>
                    <p>
                        {content.fields.title.value}
                    </p>
                    {permissionsType['change-title'] ?
                        <Button
                        size={'small'}
                        theme={'default'}
                        type={'secondary'}
                        onClick={handleEditTitle}>
                            {t('rename')}
                    </Button> : null}
                </> : null}
            </div>
            <StatusInfo data={content} onChange={setContent} handleChangeFields={handleChange}/>
            <div className={styles.general}>
                <div className={[styles.statsWrapper, content.isShowMore ? styles.more : ''].filter(x => x ?? x).join(' ')}>
                    <div className={styles.wrapper}>
                        <div className={styles.stats}>
                            <div className={styles.bill}>
                                <p>{t('sum')}, ₽</p>
                                <small>{content.overallSum}</small>
                            </div>
                            <div className={styles.expected}>
                                <p>Ожидается, ₽</p>
                                <small className={styles.expectedNumber}>{content.expectedProfit}</small>
                            </div>
                            <div className={styles.members}>
                                <p>{t('participants')}</p>
                                <small className={styles.membersNumber}>{content.overallTickets}</small>
                            </div>
                        </div>
                        <div className={styles.thumbnail}>
                            <p>{t('afisha_poster')}</p>
                            <label className={styles.img} style={content.fields.afishaImage.value ? {backgroundImage: `url(${content.fields.afishaImage.value})`} : {backgroundColor: `#5E6B92`}}>
                                {content.fields.afishaImage?.isLoading
                                    ? <Preloader/>
                                    : <div className={styles.icon}>
                                        <ImportIcon/>
                                    </div>
                                }
                                <input type='file' id="upload-photo" onChange={(e) => handleUploadImage(e)}/>
                            </label>
                        </div>
                    </div>
                    <div className={styles.site}>
                        <Switcher
                            reverse={true}
                            size={'small'}
                            value={Boolean(!content.fields.isWidget.value)}
                            onChange={permissionsType['change-widget'] ? handleSwitchWidget : null}
                        >
                            {t('widget')}
                        </Switcher>
                        <div className={styles.controls}>
                            {permissionsType['show-editor'] ? <Link to={`/admin/editor/${params.id}/`} target={'_blank'}>
                                <Button
                                    size={'small'}
                                    theme={'default'}
                                    type={'secondary'}
                                    onClick={(e) => console.log(e)}>
                                        {t('edit')}
                                </Button>
                            </Link> : null}
                            <a href={String(content.previewUrl)} target={'_blank'}>
                                <Button
                                    size={'small'}
                                    theme={'outline'}
                                    type={'secondary'}>
                                        {t('viewing')}
                                </Button>
                            </a>
                        </div>
                    </div>
                </div>
                <div className={styles.info}>
                    <ul className={styles.infoBlock}>
                        {content.eventType === 'events' ?
                            <li className={styles.dates}>
                                <CalendarIcon/>
                                <div className={styles.date}>
                                    <p>
                                        {content.fields.dates.value}
                                    </p>
                                    <small>{content.fields.datesTimezone.value}</small>
                                </div>
                            </li> : null
                        }
                        {content.fields.address.value ?
                            <li className={styles.place}>
                            <PointIcon/>
                                <p>
                                    {content.fields.address.value}
                                </p>
                            </li> : null}
                        <li className={styles.price}>
                            <TicketIcon/>
                            <div className={styles.text}>
                                {content.fields.prices.value} ₽
                            </div>
                            {content.commissionRate ? <small>{t('commission')} {content.commissionRate}%</small> : null}
                            <div className={styles.toggletip}>
                                {content.commissionRates ?
                                    <Toggletip trigger={<ToggletipIcon/>}>
                                        <ul className={styles.toggletipText}>
                                            {content.commissionRates.map((item, index) =>
                                                <li key={index}>{item}</li>
                                            )}
                                        </ul>
                                    </Toggletip> : null
                                }
                            </div>
                        </li>
                        <li className={[styles.hidden, content.isShowMore ? styles.more : ''].filter(x => x ?? x).join(' ')}>
                            <LockIcon/>
                            <p>
                                {!content.fields.isHidden.value ? `${t('open')}` : `${t('close')}`}
                            </p>
                            {permissionsType['change-hide'] ? <Button
                                size={'small'}
                                theme={'default'}
                                type={'secondary'}
                                onClick={handleHidden}>
                                {!content.fields.isHidden.value ? `${t('is_close')}` : `${t('is_open')}`}
                            </Button> : null}
                        </li>
                        {content.fields.access.value ?
                            <li className={[styles.access, content.isShowMore ? styles.more : ''].filter(x => x ?? x).join(' ')}>
                                <UserIcon/>
                                <p>
                                    {t('access')}: {content.fields.access.value}
                                </p>
                            </li> : null
                        }
                    </ul>
                    <div className={[styles.linkBlock, content.isShowMore ? styles.more : ''].filter(x => x ?? x).join(' ')}>
                        <LandingInfo data={content} onChange={onUpdate}/>
                    </div>
                </div>
            </div>
            {!content.isShowMore ? <div className={styles.showMore}>
                <Button
                    size={'small'}
                    theme={'ghost'}
                    type={'secondary'}
                    onClick={handleShowMoreInfo}>
                        <ArrowDownIcon/>
                        {t('show_more')}
                </Button>
            </div> : null}
        </div>
    );
};

export default Info;
